"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoToFavorites = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const flora_react_1 = require("@grupoboticario/flora-react");
const services_1 = require("../../../services");
const hooks_1 = require("../../../hooks");
const utils_1 = require("../../../utils");
const GoToFavorites = ({ css = {}, onClick }) => {
    const { hasFavorites, totalOfFavorites } = (0, hooks_1.useFavorites)();
    if (utils_1.envConfig.currentBrand === 'MLT') {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(flora_react_1.Box, Object.assign({ css: { position: 'relative' }, "data-autotagging-flora-section": "wishlist" }, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.IconButton, Object.assign({ "autotagging-flora": "on", "aria-label": "Ir para Favoritos", size: "small", shape: "pill", variant: "ghost", onClick: () => {
                    services_1.VWOAnalyticsService.dispatchVWOEvent('goToWishlistOnHeader');
                    onClick === null || onClick === void 0 ? void 0 : onClick();
                }, css: Object.assign({ boxShadow: 'none', color: '$nonInteractivePredominant' }, css) }, { children: (0, jsx_runtime_1.jsx)(flora_react_icons_1.HeartOutlineIcon, {}) })), hasFavorites ? ((0, jsx_runtime_1.jsx)(flora_react_1.Tag, { size: "small", css: {
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '$pill',
                    fontSize: '$xxs',
                    fontStretch: 'condensed',
                    width: '$4',
                    height: '$4',
                    backgroundColor: '$success-standard',
                }, children: ' ', "aria-hidden": "true" })) : null] })));
};
exports.GoToFavorites = GoToFavorites;
